export default __webpack_public_path__ + "static/saratov-5d0a5f31c0bae01a45eba2700066700b.webp";